module.exports = __webpack_public_path__ + "img/ecole-cfpo.24cee27e.webp";